/*
* 封装一个全局的socket.io
*/

import io from 'socket.io-client'
import Vue from 'vue'
import { UserModule } from '@/store/modules/user'
import { MessageModule } from '@/store/modules/message'

let time = null
let socket = null
let socketUrl = ''
if(process.env.NODE_ENV === 'development'){
    // socketUrl = 'ws://192.168.1.10:10072'
    socketUrl = 'ws://192.168.1.43:10072'
  }else{
    if(origin.indexOf('-testserver')>-1){
      socketUrl = 'wss://gec-api-testserver.gecacademy.cn'
    }else{
      socketUrl = 'wss://gec-api.gecacademy.cn'
    }
  }

function messagePageFun(res){
    const random = Math.random()
    res.id = random
    if (res.types === 'remind') {
        res.typeCn = '提醒'
    } else if (res.types === 'messageReviewUser') {
        res.typeCn = '审批'
        res.approvalType = '0'
    } else if (res.types === 'messageReviewCc') {
        res.typeCn = '抄送'
        res.approvalType = '2'
    } else if (res.type === "Notice") {
        res.types = "Notice"
        res.typeCn = '通知'
    }
    MessageModule.GETMSGLIST(res)
}

//   socketUrl = 'wss://gec-api-testserver.gecacademy.cn'
  function initSocket() {
    MessageModule.getMessageCount()
    socket = io(socketUrl, {
        path: process.env.NODE_ENV === 'development' ? '' : '/crmServer/socket.io',
    // socket = io('ws://192.168.0.5:10072', {
        query: {
            userId: UserModule.userId,
            room: 'defaultRoom'
        },
        transports: ["websocket", "xhr-polling", "jsonp-polling"],
        autoConnect: false
    })
    // socket.open() // 2024-5-10 断开链接

    socket.on('connect', () => {
        console.log('sokcet.io连接成功');
    })
    socket.on('disconnect', () => {
        console.log('断开连接');
    })

    // 对消息进行监听，处理crmheader出现红点
    socket.on(UserModule.userId, (res)=> {
        // console.log('res',res)
        if(res.types === "remind"){
            // console.log('-----======= 设置红点调用了')
            MessageModule.SET_REMIND_BADGE(true)
        }
        if(res.types === "remind" || res.types === "Review"  || res.types === "messageReviewUser") {
            MessageModule.getMessageCount()
        }

        messagePageFun(res)
    })

    socket.on("Notice", (res) => {

        MessageModule.getMessageCount()
        MessageModule.getMsgNoticeCount(res);

        messagePageFun(res)

    })

    Vue.prototype.$socket = socket
}


time = setInterval(() => {
    if (UserModule.userId) {
        clearInterval(time)
        initSocket()
    }
}, 10)



export default function realTimeSokcet(id: string, type: string, fun: Function) {
    socket.on(id, (res) => {
        if(res.type === type) {
            fun()
        }
    })
}

export const wastchSokcet = function (id: string) {
    return new Promise(function (resolve, reject) {
        socket.on(id, (res) => {

            const random = Math.random()
            res.id = random
            resolve(res)
        })
    })

}

